/**
 * Central definition of default risk level configuration.
 * Colors reference CSS custom properties so they adapt to dark mode automatically.
 *
 * Mappings to Global.css tokens:
 *   Low          → var(--color-success)
 *   Medium       → var(--color-warning)
 *   High         → var(--color-risk-high)
 *   Very High    → var(--color-risk-very-high)
 *   Unacceptable → var(--color-risk-unacceptable)
 */
export const DEFAULT_RISK_LEVELS = {
  'Low':          { min: 0,  max: 25,  color: 'var(--color-success)',            numericValue: 0 },
  'Medium':       { min: 25, max: 50,  color: 'var(--color-warning)',             numericValue: 1 },
  'High':         { min: 50, max: 75,  color: 'var(--color-risk-high)',           numericValue: 2 },
  'Very High':    { min: 75, max: 90,  color: 'var(--color-risk-very-high)',      numericValue: 3 },
  'Unacceptable': { min: 90, max: 100, color: 'var(--color-risk-unacceptable)',   numericValue: 4 }
};

/**
 * Resolves a CSS custom property reference (e.g. 'var(--color-success)') to its
 * computed hex/rgb value via getComputedStyle. Falls back to the original string
 * if resolution fails or runs in a non-browser environment (e.g. tests).
 *
 * Use this when a literal color value is required, e.g. <input type="color">.
 *
 * @param {string} color - A CSS variable string like 'var(--color-success)' or a hex/rgb value.
 * @returns {string} The resolved computed color, or the original value.
 */
export function resolveColor(color) {
  if (!color || !color.startsWith('var(')) return color;
  const varName = color.slice(4, -1).trim(); // 'var(--name)' → '--name'
  if (typeof getComputedStyle !== 'undefined' && typeof document !== 'undefined') {
    const resolved = getComputedStyle(document.documentElement)
      .getPropertyValue(varName)
      .trim();
    if (resolved) return resolved;
  }
  return color;
}
